module.exports = __webpack_public_path__ + "static/media/flag-checkered.d4179862.svg";